import { appConfig } from '@/config/app.config';
import type { Environment } from '@/types';
import { getCurrentEnvironment } from '@/utils/environment.utils';
import { ConsoleLoggerAdapter } from './adapters/console-logger-adapter';
import { NewRelicLoggerAdapter } from './adapters/new-relic-logger-adapter';
import { NoopLoggerAdapter } from './adapters/noop-logger-adapter';
import type { LoggerAdapter } from './logger-types';

export function createLoggerAdapter(env: Environment, forceRemote: boolean): LoggerAdapter {
  if (env === 'local') {
    return new ConsoleLoggerAdapter();
  }

  if (env === 'production') {
    return new NewRelicLoggerAdapter();
  }

  if (forceRemote) {
    return new NewRelicLoggerAdapter();
  }

  return new NoopLoggerAdapter();
}

export function getLoggerAdapter(): LoggerAdapter {
  return createLoggerAdapter(getCurrentEnvironment(), appConfig.logger.forceRemote);
}
